import React, { useState } from 'react'

const BotonAnadir = ({ columnasSeleccionadas, mostrarInformacion, setMostrarInformacion }) => {

    return (
        <>
            <div className='container-anadir'>
                <div className='botonAnadir' onClick={() => setMostrarInformacion(!mostrarInformacion)}>
                    <div className='botonAnadir-botonMas'>
                        +
                    </div>
                </div>

                {mostrarInformacion &&
                    <div className='select-seleccionar-columnas'>
                        <span className='mb-1'>Selecciona Filas</span>
                        <select onChange={columnasSeleccionadas}>
                            <option value=''>Seleccione</option>
                            <option value='1'>1</option>
                            <option value='2'>2</option>
                            <option value='3'>3</option>
                            <option value='4'>4</option>
                            <option value='5'>5</option>
                        </select>
                    </div >
                }
            </div>
        </>
    )
}

export default BotonAnadir